var Ajax = require('./ajax');
var URLMapper = require('./url-mapper');

/**
 * XServer API Client
 */
class XServerApiClient {

    /**
     * Constructor
     *
     * @param {string} serverUrl
     * @param ajaxRetryOptions
     * @param {string} s3UrlMapperRegex
     */
    constructor(serverUrl, ajaxRetryOptions, s3UrlMapperRegex) {
        this.serverUrl = serverUrl;
        this.ajaxRetryOptions = ajaxRetryOptions;
        this.s3UrlMapperRegex = s3UrlMapperRegex;
    }

    /**
     * Register image
     * @param {string} name
     * @param {number} width
     * @param {number} height
     * @returns {Promise<any>}
     */
    registerImage(name, width, height) {
        var self = this;
        return new Promise(function(resolve, reject) {

            //Build XML for soap request
            var photoXml = '<LocalPhoto><Width>' + width +
                '</Width><Heigth>' + height +
                '</Heigth><FileName><![CDATA[' + name +
                ']]></FileName></LocalPhoto>';
            var postData =
                '<?xml version="1.0" encoding="utf-8"?><soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/"><soap:Body><RegisterLocalPhotos xmlns="http://www.albumprinter.com/v20090630"><photos>' +
                photoXml +
                '</photos></RegisterLocalPhotos></soap:Body></soap:Envelope>';

            Ajax.post({
                url: self.serverUrl,
                responseType: 'XML',
                body: postData,
                retry: self.ajaxRetryOptions,
                headers: {
                    "Accept": 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8',
                    "Accept-Language": "en-US,en;q=0.5",
                    "SOAPAction": "http://www.albumprinter.com/v20090630/RegisterLocalPhotos",
                    "Content-Type": "text/xml; charset=utf-8"
                }
            }).then(function(data) {
                var xml = data.data;

                var photoId = xml.getElementsByTagName(
                    "PhotoID")[0];
                if (!photoId) {
                    reject(
                        "XServerApiClient.registerFile() unable to parse xml."
                    );
                }

                var url = xml.getElementsByTagName("Url")[0];
                var postParametersRaw = xml.getElementsByTagName(
                    "PostParameter");

                var postParameters = [];

                for (var i = 0; i < postParametersRaw.length; i++) {
                    var postParameter = postParametersRaw[i];
                    var elementName = postParameter.getElementsByTagName(
                        "Name")[0];
                    var name = (elementName.textContent ?
                        elementName.textContent :
                        elementName.childNodes[0].nodeValue
                    );
                    var elementValue = postParameter.getElementsByTagName(
                        "Value")[0];
                    var value = (elementValue.textContent ?
                        elementValue.textContent :
                        elementValue.childNodes[0].nodeValue
                    );

                    postParameters.push({
                        Name: name,
                        Value: value
                    });
                }

                resolve({
                    regId: (photoId.textContent ?
                        photoId.textContent :
                        photoId.childNodes[0].nodeValue
                    ),
                    uploadUrl: (url.textContent ?
                        url.textContent : url.childNodes[
                            0].nodeValue),
                    postParameters: postParameters
                });

            }).catch(function(error) {
                reject({
                    message: "Unable to register file",
                    error: error
                });
            });
        });
    };

    /**
     * The upload process uses this function for each
     * file to upload
     * @param {string} uploadUrl
     * @param postParameters
     * @param {Object} file
     * @param {Function} onUploadProgressCallback
     * @returns {{cancelToken: *, promise: Promise<any>}}
     */
    uploadFile(uploadUrl, postParameters, file, onUploadProgressCallback, onUploadRetryCallback) {
        var self = this;

        //The ajax request for uploading the file could take a long time, so we have a special cancelToken for that process
        var fileUploadAjaxToken = Ajax.getCancelToken();

        var promise = new Promise(function(resolve, reject) {
            var data = self._dataForm(postParameters, file);
            var promise = Ajax.post({
                    url: URLMapper.remapS3(uploadUrl, self.s3UrlMapperRegex),
                    responseType: 'XML',
                    body: data,
                    cancelToken: fileUploadAjaxToken.token,
                    retry: self.ajaxRetryOptions,
                    onUploadProgress: ((data) =>
                        onUploadProgressCallback(file, data)
                    ),
                    onUploadRetry: ((data) =>
                        onUploadRetryCallback(file, data)
                    ),
                })
                .then(function() {
                    resolve();
                })
                .catch(function(error) {
                    reject(error);
                });
        });

        return {
            cancelToken: fileUploadAjaxToken,
            promise: promise
        };
    };

    /**
     * When the upload is done, we need to set an upload complete status
     * on a webservice. This function will do that.
     *
     * @param {string} regId
     */
    setUploadCompletedStatus(regId) {
        var self = this;
        return new Promise(function(resolve, reject) {

            var data =
                '<?xml version="1.0" encoding="utf-8"?>\
                          <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">\
                            <soap:Body>\
                              <SetUploadCompleted xmlns="http://www.albumprinter.com/v20090630">\
                                <photoID><![CDATA[' +
                regId +
                ']]></photoID>\
                              </SetUploadCompleted>\
                            </soap:Body>\
                          </soap:Envelope>';

            Ajax.post({
                url: self.serverUrl,
                responseType: 'XML',
                body: data,
                headers: {
                    'Content-type': 'text/xml; charset=utf-8',
                    'SOAPAction': 'http://www.albumprinter.com/v20090630/SetUploadCompleted'
                },
                retry: self.ajaxRetryOptions
            }).then(function(xml) {
                resolve(xml);
            }).catch(function(error) {
                reject({
                    message: "Unable to set upload complete status",
                    error: error
                });
            });
        });
    };

    /**
     * Data formatter
     * @private
     * @param postParameters
     * @param file
     * @returns {FormData}
     */
    _dataForm(postParameters, file) {
        var data = new FormData();
        data.append("Filename", file.name);
        for (var i = 0; i < postParameters.length; i++) {
            data.append(postParameters[i].Name, postParameters[i].Value);
        }
        data.append('file', file);

        return data;
    };

}

module.exports = XServerApiClient;
